import { GET_POTENTIAL_CONSULTATIONS_COUNT_REQUEST } from "../../Constants/reduxRequestKeys";

export function getPotentialconsultationsCount() {
  return {
    type: GET_POTENTIAL_CONSULTATIONS_COUNT_REQUEST,
    payload: null,
  };
};
